module.exports = __webpack_public_path__ + "static/images/mastercard.1QhowM_.svg";